
let language = {
    "QP-MSG-DIALOG-MORE-TEXT": "更多",
    "QP-MSG-DIALOG-CODE-TEXT": "原因码",
    "QP-MSG-DIALOG-DSC-TEXT": "原因",
    
    "QP-MSG-DIALOG-OK-BTN-TEXT": "确认",
    "QP-MSG-DIALOG-RETRY-BTN-TEXT": "重试",
    "QP-MSG-DIALOG-CANCEL-BTN-TEXT": "取消",
};

export { language }